import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';

import { SharedService, DataService } from 'src/app/shared/services';
import { ActivatedRoute, Router } from '@angular/router';
import { JwtService } from 'src/app/auth/services';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { User} from '../../../auth/models';
import { DatePipe } from '@angular/common';
import { ITasks, IDashboardCount } from '../../models';
import { DashboardService, TasksService } from '../../services';
import { CompanyService,UserServiceAdmin } from 'src/app/users/services';
import { DVMSSystemAlertsService } from 'src/app/admin/services';
import { DvmsSystemAlertDisplayPages } from 'src/app/shared/enums/EnumsVMS';

@Component({
  selector: 'app-vendor-dashboard',
  templateUrl: './vendor-dashboard.component.html',
  styleUrls: ['./vendor-dashboard.component.css']
})
export class VendorDashboardComponent implements OnInit {
   items: MenuItem[];
  loggedInUserProfile: User;
  tasksList: ITasks[];
  dashboardCount: IDashboardCount;
  tasksCount: any;
  expirymessage:any;
  
  alertMsg: boolean = false; 
  isEnable:boolean = true;
  expiredInsurance: string = "";
  showCompanyInsuranceExpiryMessage: boolean = false;
  entitytype;
  isFirstTimeVisiable:  boolean=false;
  showAlertMessage;
  alertMessage;

  constructor(
    private sharedService: SharedService,
    private dashboardService: DashboardService,
    private tasksService: TasksService,
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private jwtService: JwtService,
    private datepipe: DatePipe,
    private companyService:CompanyService,
    private userService:UserServiceAdmin,
    private dvmsSystemAlertsService: DVMSSystemAlertsService,
  ) { }

  ngOnInit(): void {


   
    this.checkViewPermission();
    this.checkAlertMessage();
    this.getLoggedInUserProfile();
    this.getVendorTasks();
    this.getFirstLoginVendor();
    this.getVendorDashboardCount();
    this.getInsuranceExpiryInfo();
    this.checkCompanyInsuranceExpiryValidityDashboard();
    this.getEntityType();
    this.CheckVendorDocumentPendingNotificationDashboard()
    var loggedInUserRole = this.sharedService.getLoggedInUserRoles();
    if(loggedInUserRole=="Vendor Account"||loggedInUserRole=="Vendor User")
    {
      this.isEnable = false;
    }
}
  

checkViewPermission()
{
  var loggedInUserRole = this.sharedService.getLoggedInUserRoles();
  if(loggedInUserRole=="Vendor Admin" || loggedInUserRole=="Vendor User" || loggedInUserRole=="Vendor Account")
  {
    
  } else {
    this.router.navigateByUrl('/login');
  }
  
}
checkAlertMessage()
{
  this.dvmsSystemAlertsService.checkDvmsSystemAlertByPageId(DvmsSystemAlertDisplayPages.DashboardVendorPage).subscribe((data:any)=>{
    if(data.hasAlertAvailable == true)
    {
      this.showAlertMessage = true;
      this.alertMessage = data.alertMessage;
    }
  }); 
}
getLoggedInUserProfile()
{
  this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
  /*console.log('this.loggedInUserProfile');
  console.log(this.loggedInUserProfile.cid);*/
}


getVendorTasks()
{
  this.tasksService.getVendorTasks(Number(this.loggedInUserProfile.cid)).subscribe((data: any) => {
    /*console.log('my tasks data');
    console.log(data);*/
    this.tasksList = data;
    this.tasksCount = (this.tasksList.length>0) ? this.tasksList.length : 0;
  });
}

getInsuranceExpiryInfo()
{
  this.companyService.getInsuranceExpiryInfo(Number(this.loggedInUserProfile.cid)).subscribe((data: any) => {
    //console.log(data);
    this.expirymessage=data.result;
    if (data.result == "") {
      this.expirymessage = "";
      this.alertMsg=false;
    } else {
      this.expirymessage = data.result;
      this.alertMsg=true;
    }
  });
}

getEntityType()
{
  this.companyService.getEntityTypeFromCompanyId(Number(this.loggedInUserProfile.cid)).subscribe((entitydata:any) =>{
    this.entitytype = entitydata.description;
  });
}

editCompany(){
  if(this.entitytype == 'Individual')
  {
    this.router.navigate(['/users/vendor-individual-edit', { companyId: Number(this.loggedInUserProfile.cid),tabId: 6  }]);
  }
  else
  {
    this.router.navigate(['/users/vendor-edit-old', { companyId: Number(this.loggedInUserProfile.cid),tabId: 6 }]);
  }
}

viewTask(applicantReferenceId:string,submissionReferenceId:string){
  var tmpapplicantReferenceId = (applicantReferenceId=== null || applicantReferenceId === undefined)? 0 : applicantReferenceId
  var tmpsubmissionReferenceId = (submissionReferenceId=== null || submissionReferenceId === undefined)? 0 : submissionReferenceId
  this.router.navigate(['/applicant/applicant-view/',tmpapplicantReferenceId,tmpsubmissionReferenceId]);
}


getVendorDashboardCount()
{
  this.dashboardService.getVendorDashboardCount(Number(this.loggedInUserProfile.cid)).subscribe((data: any) => {
    /*console.log('my dashboard count');
    console.log(data);*/
    this.dashboardCount = data;
  });
}
checkCompanyInsuranceExpiryValidityDashboard()
    {
            this.companyService.checkCompanyInsuranceExpiryValidityDashboard(Number(this.loggedInUserProfile.cid)).subscribe((data:any)=>{
            this.expiredInsurance = data.status;
            if(this.expiredInsurance==="" || this.expiredInsurance === null)
            {
                this.showCompanyInsuranceExpiryMessage = false;
            }
            else
            {
                this.showCompanyInsuranceExpiryMessage = true;
            }
            console.log('this.expiredInsurance');
            console.log(this.expiredInsurance);
          });
    }
    showDocumentPendingNotificationMessage:boolean=false;
    CheckVendorDocumentPendingNotificationDashboard()
    {
            this.dashboardService.CheckVendorDocumentPendingNotification(Number(this.loggedInUserProfile.cid)).subscribe((data:any)=>{
            this.showDocumentPendingNotificationMessage = data;
          });
    }

getFirstLoginVendor()
{
  this.userService.getUserProfileByUserId(Number(this.loggedInUserProfile.uid)).subscribe((data: any) => {
  
    this.isFirstTimeVisiable = data.isFirstViewDashBoard;
  });
}
cancelFirstTimeVisiableDialog() {
      this.userService.UpdateFirstViewDashBoard(Number(this.loggedInUserProfile.uid)).subscribe(data => {
      });
      
      this.isFirstTimeVisiable = false;     
}

}
